module.exports = __webpack_public_path__ + "img/baby-vinyl_thumbnail.7b25e73f.jpg";